import ContactForm from './ContactForm.svelte';

export default {
  component: ContactForm,
  name: 'ContactForm',
  inputs: [
    {
      name: 'formSubjects',
      type: 'list',
      subFields: [
        {
          type: 'string',
          name: 'label'
        },
        {
          type: 'string',
          name: 'value'
        }
      ]
    },
    {
      name: 'formRecipentEmail',
      type: 'string'
    },
    {
      name: 'namePlaceholder',
      type: 'string',
    },
    {
      name: 'emailPlaceholder',
      type: 'string',
    },
    {
      name: 'subjectPlaceholder',
      type: 'string',
    },
    {
      name: 'messagePlaceholder',
      type: 'string',
    },
    {
      name: 'submitLabel',
      type: 'string',
    },
  ]
}